import axios from "axios";
import { ElMessage, ElLoading } from "element-plus";
import store from "@/store";
import router from "@/router";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 1000000,
});

let loadingInstance;

const getLocale = () => {
  return localStorage.getItem('locale') || 'zh-CN';
};

service.interceptors.request.use(
  (config) => {
    if (store.state.token) {
      config.headers["Authorization"] = store.state.token;
    }
    config.headers["Accept-Language"] = getLocale();
    loadingInstance = ElLoading.service({
      fullscreen: true,
      text: "拼命加载中...",
    });
    return config;
  },
  (error) => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (res) => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    const code = res.data.code;
    if (code === 0) {
      return Promise.resolve(res.data);
    } else if (code === 401) {
      console.log(res, '登录信息已失效，请重新登录');
      store.dispatch('logout').then(() => {
        router.replace('/home');
        ElMessage.error("登录信息已失效，请重新登录");
      });
      return Promise.reject(res.data);
    } else if (code === 499) {
      window.dispatchEvent(new CustomEvent('showMaintenancePage'));
      return Promise.reject("error");
    } else if (code === 500) {
      ElMessage.error(res.data.msg || '服务器错误');
      return Promise.reject("error");
    } else if (code === 601) {
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error);
    if (loadingInstance) {
      loadingInstance.close();
    }

    let errorMsg = '请求失败';
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.dispatch('logout').then(() => {
            router.replace('/home');
            ElMessage.error('登录已过期，请重新登录');
          });
          break;
        case 404:
          errorMsg = '请求的资源不存在';
          break;
        case 500:
          errorMsg = '服务器内部错误';
          break;
        default:
          errorMsg = error.response.data?.msg || '请求失败';
      }
      ElMessage.error(errorMsg);
    } else if (error.request) {
      ElMessage.error('网络连接失败，请检查网络');
    } else {
      ElMessage.error('请求配置错误');
    }
    return Promise.reject(error);
  },
);

export default service;
